export default __webpack_public_path__ + "maps-examples-source-custom-vector-thumbnail-480-98657cdf82cc8823473a1b3617b465df.png";